import { useQuery } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Carga los usuarios asignables del modulo de tickets para una sede concreta.
// React Query cachea el resultado por sede (queryKey incluye headquarter).
const useTicketsUsuarios = (headquarter) =>
  useQuery({
    queryKey: ticketsKeys.usuarios(headquarter),
    queryFn: async () => {
      const data = await ticketsService.listarUsuarios({ headquarter });
      return Array.isArray(data) ? data : [];
    },
    enabled: Boolean(headquarter),
    staleTime: 5 * 60 * 1000,
  });

export default useTicketsUsuarios;
